import * as Api from '@api';

const ContactForm = dynamic(() => import('@/app/parts/global/ContactForm'));
import contactForm from "@/styles/modules/contactform.module.scss";
import form from "@/styles/modules/sample_form.module.scss";
import * as C from "@components";
import dynamic from "next/dynamic";

const pageSlug = "samples-form";

const ContactFormWrapperKeys = [
    "title",
    "body",
    "body.2",
    "button",
] as const;

interface ContactFormWrapperProps {
    title?: string;
    body?: 'body' | 'body.2';
    background?: string;
}

export const ContactFormWrapper = async (_props: ContactFormWrapperProps) =>
{
    const pageContent = await Api.PageService.getBareContentBySlug(pageSlug, ContactFormWrapperKeys);

    return (
        <section className={form.sample_form__wrapper} id={"contact-us"}>
            <div className="container">
                <div className={`${form.sample_form__wrapper_block} ${_props.background ?? ''}`}>
                    <h2 className={form.title}>{_props.title ? _props.title : pageContent["title"].data}</h2>
                    <C.InplaceVideo muted autoPlay
                                    imagePlaceholder={"/images/sample-form-mobile2x.png"}
                                    imagePlaceholderAlt="Get samples and pricing"
                                    imagePlaceholderWidth={255}
                                    imagePlaceholderHeight={231}
                    >
                        <source src="/video/contact-video.mp4" />
                    </C.InplaceVideo>
                    <div className={form.sample_form__wrapper_block_text}>
                        {/*<figure className="md:hidden">
                            <ExportedImage src="/images/sample-form-mobile2x.png"
                                width="255" height={231} alt="Get samples and pricing" className={"image-align-center"} />
                        </figure>*/}
                        <p>{pageContent[_props.body ?? "body"]?.data}</p>
                        <div className={contactForm.zoho_form_wrapper}><ContactForm pageContent={pageContent} /></div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactFormWrapper;